import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/api';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface PerfilExclusaoProps {
    show: boolean;
    idPerfil: string;
    onHide: () => void;
    onExcluir: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function PerfilExclusao(props: PerfilExclusaoProps) {
    const [nome, setNome] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoPerfil, setCarregandoPerfil] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoPerfil(true);
            api.get(`/Perfil/${props.idPerfil}`)
                .then(response => {
                    setNome(response.data.nome);
                    setCarregandoPerfil(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoPerfil(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        api.delete(`/Perfil/${props.idPerfil}`, data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível excluir o perfil: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoPerfil
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir o perfil ${nome}?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default PerfilExclusao;